import { instance } from '@configs';
import { useMutation } from '@tanstack/react-query';

import {
  redirect,
  removeAmountCommissionsSStorage,
  removeAmountSStorage,
} from '@utils';
import { IResponse } from '@types';

import { PayLinkProcardpayRoute } from './constants';
import { IUrl } from './types';

export const usePayLinkProcardpayQuery = (sessionToken: string) => {
  return useMutation({
    mutationFn: async () => {
      const { data } = await instance.post<IResponse<IUrl>>(
        PayLinkProcardpayRoute.PayLinkProcardpay,
        undefined,
        {
          headers: {
            SessionToken: sessionToken,
          },
        }
      );
      return data;
    },
    onSuccess(data) {
      if (data.code === 200) {
        removeAmountSStorage();
        removeAmountCommissionsSStorage();
      }
      redirect(data.payload.url);
    },
  });
};
